require('./_typed-array')('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/ecf67698/0/pomelo/oceopin/web/app/themes/oceopin/node_modules/core-js/modules/es6.typed.float64-array.js
// module id = 254
// module chunks = 0